export default function LinkedIn({ className }: { className?: string }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.62598 4.58602C2.62598 3.53131 3.50823 2.67578 4.59659 2.67578H27.322C28.4104 2.67578 29.2927 3.53131 29.2927 4.58602V27.4322C29.2927 28.4872 28.4104 29.3424 27.322 29.3424H4.59659C3.50823 29.3424 2.62598 28.4872 2.62598 27.4322V4.58602ZM10.6848 24.984V12.9033H6.66934V24.984H10.6848ZM8.67703 11.2538C10.0773 11.2538 10.9488 10.3262 10.9488 9.16685C10.9227 7.98143 10.0773 7.0795 8.7036 7.0795C7.33004 7.0795 6.43196 7.98143 6.43196 9.16685C6.43196 10.3262 7.30332 11.2538 8.65086 11.2538H8.67703ZM16.922 24.984H12.9067C12.9067 24.984 12.9594 14.0368 12.9067 12.9033H16.9221V14.6136C17.4557 13.7904 18.4108 12.6198 20.5408 12.6198C23.1827 12.6198 25.1636 14.3464 25.1636 18.0571V24.984H21.1485V18.5211C21.1485 16.8971 20.5673 15.7892 19.1144 15.7892C18.0051 15.7892 17.3444 16.5364 17.0541 17.2578C16.948 17.5159 16.922 17.8766 16.922 18.2376V24.984ZM16.9221 14.6136V14.6552H16.8952C16.9041 14.6415 16.9131 14.6276 16.9221 14.6136Z"
        fill="currentColor"
      />
    </svg>
  );
}
